<template>
  <div class="wrap">
    <div class="back-button" @click="onClick">
      <div class="icon"></div>
      <div class="label">{{ $t('back') }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.wrap {
  margin: 1em 0;
  display: flex;
}
.back-button {
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover {
    .label {
      text-decoration: underline;
    }
  }

  .icon {
    width: 0.7em;
    height: 0.7em;
    border-top: 2px #000 solid;
    border-left: 2px #000 solid;
    transform: rotateZ(-45deg);
  }
}
</style>

<script>
export default {
  name: 'back-button',
  props: {
    to: {
      type: String,
      default: null
    }
  },
  methods: {
    onClick () {
      if (this.to) {
        this.$router.push(this.to)
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
